function loading() {
  document.body.classList.add('is-loaded');
}

export {loading};
